import React from 'react';
import PropTypes from 'prop-types';
HierarchyDefaultNode.propTypes = {
  node: PropTypes.object
};
export default function HierarchyDefaultNode(_ref) {
  var node = _ref.node;
  return React.createElement("circle", {
    cx: node.x,
    cy: node.y,
    r: 15,
    fill: "#21D4FD"
  });
}